<div class="wrap">
  <div class="search_and_map">
    <div class="background_search">
      <div class="search_bar">
        <input type="text" placeholder="Chercher un article ..." [formControl]="myControl" [matAutocomplete]="auto"
          (keypress)="getDetails($event)">
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
        <fa-icon [icon]=" faSearch"></fa-icon>
      </div>
    </div>
    <div class="map">
      <app-map></app-map>
    </div>
    <div class="left">
      <fa-icon [icon]="faChevronLeft"></fa-icon>
    </div>
    <div class="right">
      <fa-icon [icon]="faChevronRight"></fa-icon>
    </div>
  </div>
  <mat-tab-group mat-align-tabs="center" *ngIf="!meteoDetail">
    <mat-tab label="Aujourd'hui">
      <div class="weather_city" *ngFor="let m of meteo">
        <app-favorite></app-favorite>
        <div class="weather_city_content">
          <div class="first_line">
            <div class="city">{{m.title}}</div>
            <div class="wind">
              <img src="assets/img/icon-blue/wind.svg" alt="wind">
            </div>
            <div class="wind_speed">
              {{m.feeds[0].windSpeed}}kts <br>
              <span>rafales {{m.feeds[0].windGust || 0}}kts</span>
            </div>
            <div class="wave">
              <img src="assets/img/icon-blue/vague.svg" alt="">
              {{m.feeds[0].waveDirection}} {{m.feeds[0].swellPeriodicity}}s
            </div>
          </div>
          <div class="seconde_line">
            <div class="temp">
              {{m.feeds[0].airTemperature}}°C / {{m.feeds[0].airQuality}}°C
            </div>
            <div class="cloud"> <img src="assets/img/icon-blue/cloud_blue.svg" alt="cloud"></div>
            <div class="weather_comment">{{m.feeds[0].weather}}</div>
            <div class="humidity">
              <img src="assets/img/icon-blue/umbrella.svg" alt="umbrella">
              <p>{{m.feeds[0].humidity}}%</p>
            </div>
          </div>
        </div>
        <app-like></app-like>
      </div>
    </mat-tab>
    <mat-tab label="Matin">
    </mat-tab>
    <mat-tab label="Midi">
    </mat-tab>
    <mat-tab label="Soir">
    </mat-tab>
    <mat-tab label="TEMPS PERSO">
    </mat-tab>
  </mat-tab-group>
  <app-meteo-details [(city)]="city" *ngIf="meteoDetail"></app-meteo-details>
</div>

<!-- <app-map></app-map> -->
